import React from 'react';
import { Reveal } from './Reveal';
export function Problem() {
  return <section className="w-full bg-ink py-24" data-id="element-125">
      <div className="mx-auto max-w-4xl px-6" data-id="element-126">
        <Reveal data-id="element-127">
          <h2 className="font-display text-3xl font-semibold text-cream sm:text-4xl" data-id="element-128">
            El problema de los "Casi Algo" es que no hay un cadáver que
            enterrar.
          </h2>
        </Reveal>

        <div className="mt-10 space-y-6 text-lg leading-relaxed text-muted" data-id="element-129">
          <Reveal delay={0.05} data-id="element-130">
            <p data-id="element-131">
              No hay fotos de boda que romper ni una casa que dividir. Solo hay
              una montaña de
              <span className="text-cream" data-id="element-132"> "hubieras"</span> y una esperanza
              tóxica que te susurra que, si tan solo hicieras algo diferente,
              ellos finalmente te elegirían.
            </p>
          </Reveal>
          <Reveal delay={0.1} data-id="element-133">
            <p className="border-l-2 border-rose-glow pl-6 font-display text-2xl italic text-cream" data-id="element-134">
              Te duele más que una ruptura formal porque no estás de luto por el
              pasado, estás de luto por el futuro que inventaste en tu cabeza.
            </p>
          </Reveal>
          <Reveal delay={0.15} data-id="element-135">
            <p data-id="element-136">
              Mientras tanto, tu autoestima se desangra esperando una validación
              que nunca llegará de esa mano.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}